module.exports = __webpack_public_path__ + "img/logo_v2.c2b51ee5.png";